// extracted by mini-css-extract-plugin
module.exports = {"root":"f4tNDJ","title":"tjGClK","message":"AHDUMS","text":"lmVjlv"};